import { OutlinedTextFieldProps } from '@mui/material'
import { Box } from '@mui/system'
import { useTranslation } from 'react-i18next'
import { v4 as uuidv4 } from 'uuid'
import LoginInput from './LoginInput'

export interface ILoginInputProps extends Partial<OutlinedTextFieldProps> {
  errorMessage?: string
}

const LoginEmail = (props: ILoginInputProps) => {
  const {t} = useTranslation();
  
  return (
    <LoginInput
      {...props}
      id={`login-email-${uuidv4()}`}
      type="email"
      placeholder={t('login.connection.email')}
      InputProps={{
        ...props.InputProps,
        startAdornment: (
          <Box sx={{ color: 'common.accent', fontSize: '16px', mr: '10px' }}>
            <i className="fa-light fa-paper-plane" />
          </Box>
        ),
      }}
    />
  )
}

export default LoginEmail
